module.exports = __webpack_public_path__ + "img/29.7b6d1d30.png";